import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Card, Button, Row} from 'react-materialize';

import checklist from '../../images/checklist.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';


class ChecklistGeral extends Component {

    constructor(props) {
        super(props);
        //this.routeChange= this.routeChange.bind(this);

        this.showDiv1 = this.showDiv1.bind(this);
        this.showDiv2 = this.showDiv2.bind(this);
        this.showDiv3 = this.showDiv3.bind(this);
        this.showDiv4 = this.showDiv4.bind(this);
        this.showDiv5 = this.showDiv5.bind(this);
        this.showDiv6 = this.showDiv6.bind(this);
        this.showDiv7 = this.showDiv7.bind(this);
        this.showDiv8 = this.showDiv8.bind(this);
        this.showDiv9 = this.showDiv9.bind(this);
        this.showDiv10 = this.showDiv10.bind(this);
        this.showDiv11 = this.showDiv11.bind(this);
        this.showDiv12 = this.showDiv12.bind(this);
        this.showDiv13 = this.showDiv13.bind(this);
        this.showDiv14 = this.showDiv14.bind(this);
        this.showDiv15 = this.showDiv15.bind(this);
        this.showDiv16 = this.showDiv16.bind(this);
        this.showDiv17 = this.showDiv17.bind(this);
        this.showDiv18 = this.showDiv18.bind(this);
        this.showDiv19 = this.showDiv19.bind(this);
        this.showDiv20 = this.showDiv20.bind(this);


        this.state ={
            showComponent1: false,
            showComponent2: false,
            showComponent3: false,
            showComponent4: false,
            showComponent5: false,
            showComponent6: false,
            showComponent7: false,
            showComponent8: false,
            showComponent9: false,
            showComponent10: false,
            showComponent11: false,
            showComponent12: false,
            showComponent13: false,
            showComponent14: false,
            showComponent15: false,
            showComponent16: false,
            showComponent17: false,
            showComponent18: false,
            showComponent19: false,
            showComponent20: false,
        }

    }

/*
    handleChange(){
        this.state ={
        showComponent1: false,
    };}

    handleChange2(){
        this.state ={
            showComponent2: false,
        };}

    handleChange3(){
        this.state ={
            showComponent3: false,
        };}

    handleChange4(){
        this.state ={
            showComponent4: false,
        };}

    handleChange5(){
        this.state ={
            showComponent5: false,
        };}

    handleChange6(){
        this.state ={
            showComponent6: false,
        };}

    handleChange7(){
        this.state ={
            showComponent7: false,
        };}

    handleChange8(){
        this.state ={
            showComponent8: false,
        };}

    handleChange9(){
        this.state ={
            showComponent9: false,
        };}

    handleChange10(){
        this.state ={
            showComponent10: false,
        };}

    handleChange11(){
        this.state ={
            showComponent11: false,
        };}

    handleChange12(){
        this.state ={
            showComponent12: false,
        };}

    handleChange13(){
        this.state ={
            showComponent13: false,
        };}

    handleChange14(){
        this.state ={
            showComponent14: false,
        };}

    handleChange15(){
        this.state ={
            showComponent15: false,
        };}

    handleChange16(){
        this.state ={
            showComponent16: false,
        };}

    handleChange17(){
        this.state ={
            showComponent17: false,
        };}

    handleChange18(){
        this.state ={
            showComponent18: false,
        };}

    handleChange19(){
        this.state ={
            showComponent19: false,
        };}

    handleChange20(){
        this.state ={
            showComponent20: false,
        };}
*/
    /*
    routeChange(){
        let path= './checklist_geral_resp';
        this.props.history.push(path);
    }*/

    showDiv1 = (e) => {
        this.setState({
            showComponent1: e.target.checked,
        });
    };

    showDiv2 = (e) => {
        this.setState({
            showComponent2: e.target.checked,
        });
    };

    showDiv3 = (e) => {
        this.setState({
            showComponent3: e.target.checked,
        });
    };

    showDiv4 = (e) => {
        this.setState({
            showComponent4: e.target.checked,
        });
    };

    showDiv5 = (e) => {
        this.setState({
            showComponent5: e.target.checked,
        });
    };

    showDiv6 = (e) => {
        this.setState({
            showComponent6: e.target.checked,
        });
    };

    showDiv7 = (e) => {
        this.setState({
            showComponent7: e.target.checked,
        });
    };

    showDiv8 = (e) => {
        this.setState({
            showComponent8: e.target.checked,
        });
    };

    showDiv9 = (e) => {
        this.setState({
            showComponent9: e.target.checked,
        });
    };

    showDiv10 = (e) => {
        this.setState({
            showComponent10: e.target.checked,
        });
    };

    showDiv11 = (e) => {
        this.setState({
            showComponent11: e.target.checked,
        });
    };
    showDiv12 = (e) => {
        this.setState({
            showComponent12: e.target.checked,
        });
    };

    showDiv13 = (e) => {
        this.setState({
            showComponent13: e.target.checked,
        });
    };

    showDiv14 = (e) => {
        this.setState({
            showComponent14: e.target.checked,
        });
    };

    showDiv15 = (e) => {
        this.setState({
            showComponent15: e.target.checked,
        });
    };

    showDiv16 = (e) => {
        this.setState({
            showComponent16: e.target.checked,
        });
    };

    showDiv17 = (e) => {
        this.setState({
            showComponent17: e.target.checked,
        });
    };

    showDiv18 = (e) => {
        this.setState({
            showComponent18: e.target.checked,
        });
    };

    showDiv19 = (e) => {
        this.setState({
            showComponent19: e.target.checked,
        });
    };

    showDiv20 = (e) => {
        this.setState({
            showComponent20: e.target.checked,
        });
    };

    render() {

        return(
        <Card>

            <Row>
                <div className={"text-center"} align="center">
                    <img src={checklist} className={"img"} alt={"Aquasafe logo"} width={"100"} height={"100"}/>
                </div>
            </Row>

            <div  align={"center"}>
            <h5><b><FormattedMessage id={"checklistgp"} defaultMessage={"Checklist de Procedimentos Gerais"}/></b></h5>
            </div>

            <div className={"margin"}>

            <p><FormattedMessage id={"checklist.text"} defaultMessage={"Estas práticas são adotadas em seu local de trabalho?"}/></p>

            </div>
            <div className={"forms"}>
                <form action={"#"}>
                    <p>
                        <input type={"checkbox"} id={"item1"} onClick={this.showDiv1}/>
                        <label htmlFor={"item1"}><FormattedMessage id={"gp.1"} defaultMessage={"Não utilizo equipamentos de proteção individual, tais como luvas, bonés, protetor solar, máscaras e colete salva-vidas."}/></label>

                        {this.state.showComponent1 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.1"}  defaultMessage={"Utilize sempre equipamentos de proteção individual para garantir sua saúde e proteção."}/> </p>  </div>: null }
                    </p>



                    <p>
                        <input type={"checkbox"} id={"item2"} onClick={this.showDiv2}/>
                        <label htmlFor={"item2"}><FormattedMessage id={"gp.2"} defaultMessage={"A vegetação em torno de tanques e instalações não é cortada frequentemente."}/></label>

                        {this.state.showComponent2 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.2"} defaultMessage={"Mantenha a vegetação rasteira para evitar esconderijo e abundância de animais."}/> </p>  </div>: null }

                            </p>

                    <p>
                        <input type={"checkbox"} id={"item3"} onClick={this.showDiv3}/>
                        <label htmlFor={"item3"}> <FormattedMessage id={"gp.3"} defaultMessage={"Não é realizado frequentemente controle de pragas e vetores."}/>
                        </label>

                        {this.state.showComponent3 ? <div className={"hidden-div"}> <p> <FormattedMessage id={"gpa.3"} defaultMessage={"Faça controle de pragas periodicamente para evitar insetos, roedores e outros animais ou vetores de doenças  no local de trabalho."}/> </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item4"} onClick={this.showDiv4}/>
                        <label htmlFor={"item4"}> <FormattedMessage id={"gp.4"} defaultMessage={"Ambiente de trabalho não é limpo e organizado."}/></label>

                        {this.state.showComponent4 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.4"} defaultMessage={"Ambiente de trabalho limpo e organizado evita danos à saúde do trabalhador e influência na qualidade da empresa."}/> </p>  </div>: null }

                    </p>

                    <p>
                        <input type={"checkbox"} id={"item5"} onClick={this.showDiv5}/>
                        <label htmlFor={"item5"}><FormattedMessage id={"gp.5"} defaultMessage={"As instalações elétricas não são impermeabilizadas, não possuem uso de fusíveis e conexão de aterramento adequada."}/>
                        </label>

                        {this.state.showComponent5 ? <div className={"hidden-div"}> <p> <FormattedMessage id={"gpa.5"} defaultMessage={"Uso de fusíveis, instalações elétricas impermeabilizadas e aterradas diminuem o risco de choque elétrico."}/> </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item6"} onClick={this.showDiv6}/>
                        <label htmlFor={"item6"}><FormattedMessage id={"gp.6"} defaultMessage={"Para evitar afogamentos, os trabalhadores não usam bóias ou coletes salva-vidas nas atividades em contato com a água."}/>
                        </label>

                        {this.state.showComponent6 ? <div className={"hidden-div"}> <p> <FormattedMessage id={"gpa.6"} defaultMessage={"O uso de bóias, linhas ou coletes salva-vidas em atividades com contato de água evitam afogamentos e possíveis mortes."}/> </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item7"} onClick={this.showDiv7}/>
                        <label htmlFor={"item7"}><FormattedMessage id={"gp.7"} defaultMessage={"Não há pausas frequentes e rotação de trabalhadores para evitar exposições prolongadas."}/></label>
                        {this.state.showComponent7 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.7"} defaultMessage={"Trabalhos que exigem algum tipo de exposição prolongada deve ser acompanhada de pausas frequentes e rotação de trabalhadores a fim de evitar problemas de saúde imediatos ou futuros."}/>
                        </p>  </div>: null }

                    </p>

                    <p>
                        <input type={"checkbox"} id={"item8"} onClick={this.showDiv8}/>
                        <label htmlFor={"item8"}><FormattedMessage id={"gp.8"} defaultMessage={"O ambiente de trabalho não é sinalizado para riscos."}/></label>
                        {this.state.showComponent8 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.8"} defaultMessage={"A sinalização no ambiente de trabalho auxilia na prevenção de riscos e devem ser utilizados para alertar possíveis acidentes. "}/></p>  </div>: null }

                    </p>

                    <p>
                        <input type={"checkbox"} id={"item9"} onClick={this.showDiv9}/>
                        <label htmlFor={"item9"}><FormattedMessage id={"gp.9"} defaultMessage={"O transporte de carga pelo trabalhador não é realizado a fim de evitar levantamento de peso em excesso."}/></label>
                        {this.state.showComponent9 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.9"} defaultMessage={"Utilizar equipamentos mecânicos para eliminar ou diminuir o esforço físico. Utilizar polia, trilho ou guindaste para levantar redes na despesca ou transportar cargas. Caso a carga transportada estiver com peso em excesso é preciso retirar a carga excessiva a fim de evitar problemas de saúde futuros e acidentes. "}/> </p>  </div>: null }

                    </p>

                    <p>
                        <input type={"checkbox"} id={"item10"} onClick={this.showDiv10}/>
                        <label htmlFor={"item10"}><FormattedMessage id={"gp.10"} defaultMessage={"As pessoas envolvidas no processo produtivo não foram suficientemente treinadas para suas funções."}/>
                        </label>

                        {this.state.showComponent10 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.10"} defaultMessage={"O pessoal envolvido nas atividades na aquicultura deverá usar EPIs específicos e receber treinamentos e atualizações para suas funções."}/> </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item11"} onClick={this.showDiv11}/>
                        <label htmlFor={"item11"}><FormattedMessage id={"gp.11"} defaultMessage={"Saber nadar ou mergulhar não é indispensável para contratação no local de trabalho."}/>
                        </label>

                        {this.state.showComponent11 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.11"} defaultMessage={"Saber nadar ou mergulhar pode evitar acidentes como afogamentos fatais. "}/></p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item12"} onClick={this.showDiv12}/>
                        <label htmlFor={"item12"}><FormattedMessage id={"gp.12"} defaultMessage={"Produtos químicos não são aplicados utilizando máscaras e luvas apropriadas."}/>
                        </label>

                        {this.state.showComponent12 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.12"} defaultMessage={"O uso de máscaras e luvas ao manusear produtos químicos é necessário para evitar intoxicações e queimaduras. Verifique o manual de instruções do produto para correta utilização de equipamentos de proteção. Sempre que possível, substituir produtos tóxicos ou letais. Produtos químicos devem ser armazenados apropriadamente em áreas bem ventiladas e separadas das substâncias incompatíveis."}/> </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item13"} onClick={this.showDiv13}/>
                        <label htmlFor={"item13"}><FormattedMessage id={"gp.13"} defaultMessage={"Trabalhadores não são orientados a possuir algum tipo de imunização (tétano, hepatite A e B, febre tifóide, gripe e/ou febre amarela)."}/></label>

                        {this.state.showComponent13 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.13"} defaultMessage={"A maioria dos países não possui uma normativa especial de vacinas para trabalhadores da aquicultura, porém é recomendado que trabalhadores que têm contato direto com animais e água realizem as vacinas de Tétano, Hepatite A e B, febre tifóide, gripe e/ou febre amarela."}/> </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item14"} onClick={this.showDiv14}/>
                        <label htmlFor={"item14"}><FormattedMessage id={"gp.14"} defaultMessage={"No meu ambiente de trabalho, não é possível realizar pausas ou mudança de posição após longos períodos de atividade."}/></label>

                        {this.state.showComponent14 ? <div className={"hidden-div"}> <p> <FormattedMessage id={"gpa.14"} defaultMessage={"Pausas, manter boa postura ou mudanças de posição durante os períodos de trabalho são essenciais quando as tarefas são repetitivas ou precisam ser realizadas em uma posição específica."}/> </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item15"} onClick={this.showDiv15}/>
                        <label htmlFor={"item15"}><FormattedMessage id={"gp.15"} defaultMessage={"Não utilizo luvas resistente ao corte no manuseio de equipamentos ou máquinas afiadas."}/> </label>

                        {this.state.showComponent15 ? <div className={"hidden-div"}> <p> <FormattedMessage id={"gpa.15"} defaultMessage={"Luvas resistentes para manusear equipamentos ou máquinas afiadas é recomendada para evitar cortes e perfurações mais graves. Existem no mercado luvas de poliuretano de alta resistência que protegem o trabalhador contra cortes e outras lesões."}/>
                        </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item16"} onClick={this.showDiv16}/>
                        <label htmlFor={"item16"}><FormattedMessage id={"gp.16"} defaultMessage={"Equipamentos ou máquinas no meu local de trabalho não possuem “chave de bloqueio” para não ser acionado durante o manuseio."}/>
                        </label>

                        {this.state.showComponent16 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.16"} defaultMessage={"Chaves de bloqueio de máquinas e equipamentos devem ser instaladas e os trabalhadores treinados e orientados  sobre a exigência deste mecanismo para evitar acionar equipamentos durante limpeza ou outro trabalho. Dessa forma, evita-se lesões graves como perdas de membros ou acidentes fatais como acionar fornalhas, trituradores ou câmaras de refrigeração (e assemelhados) quando um trabalhador estiver dentro."}/>

                        </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item17"} onClick={this.showDiv17}/>
                        <label htmlFor={"item17"}><FormattedMessage id={"gp.17"}  defaultMessage={"Os trabalhadores não estão cientes das suas responsabilidades de saúde e segurança e foram avisados ​​de quaisquer riscos potenciais (físicos, químicos, ergonomia, saúde, biológicos) que eles podem encontrar no trabalho."}/>
                        </label>

                        {this.state.showComponent17 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.17"} defaultMessage={"Os trabalhadores devem estar cientes e treinados sobre suas responsabilidades em saúde e segurança, bem como sobre os riscos potenciais."}/> </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item18"} onClick={this.showDiv18}/>
                        <label htmlFor={"item18"}><FormattedMessage id={"gp.18"} defaultMessage={"Não somente funcionários autorizados e treinados podem operar ferramentas e equipamentos ou usar produtos químicos."}/></label>

                        {this.state.showComponent18 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.18"} defaultMessage={"Todos trabalhadores devem ser treinados para operar máquinas, ferramentas, equipamentos e produtos químicos, de forma a minimizar o risco de acidentes. "}/></p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item19"} onClick={this.showDiv19}/>
                        <label htmlFor={"item19"}><FormattedMessage id={"gp.19"} defaultMessage={"Não existem oportunidades de capacitação profissional e familiarização para novos trabalhadores?"}/></label>

                        {this.state.showComponent19 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.19"} defaultMessage={"Capacitação de trabalhadores é fundamental."}/>  </p>  </div>: null }
                    </p>

                    <p>
                        <input type={"checkbox"} id={"item20"} onClick={this.showDiv20}/>
                        <label htmlFor={"item20"}><FormattedMessage id={"gp.20"} defaultMessage={"Não existem trabalhadores experientes e responsáveis ​​a quem recorrer se outros trabalhadores precisarem assistência?"}/>
                        </label>

                        {this.state.showComponent20 ? <div className={"hidden-div"}> <p><FormattedMessage id={"gpa.20"} defaultMessage={"Trabalhadores ou profissionais experientes são importantes para recorrer em casos de necessidade de assistência ou suporte nas atividades."}/> </p>  </div>: null }
                    </p>

                </form>
            </div>

            {/*
            <div>
                <Button waves={'light'} className={"btnChecklist"}
                onClick={this.routeChange}>Submeter</Button>
            </div> */}
        </Card>
        )
    }
}

export default withRouter(ChecklistGeral);